import validator from 'validator';
import passwordValidator from '../../../../shared/utils/password-validator';

const nameValidator = (value: string, key: string): string => {
  if (validator.isEmpty(value)) {
    return `${key} name is required.`;
  }
  if (!validator.isAlpha(value)) {
    return `Alphabetic characters only.`;
  }
  if (!validator.isLength(value, { min: 2, max: 25 })) {
    return `Should be between 2-25 characters.`;
  }
  return '';
};

export const trimDialCode = (
  phoneNumber?: string,
  dialCode?: string,
): string => {
  const dialCodeLength = dialCode?.toString().length ?? 0;
  return phoneNumber?.toString().substring(dialCodeLength) ?? '';
};

export const validate = (
  name: string,
  value: string,
  dialCode: string,
  shouldShowPhoneNumberInput: boolean,
): string => {
  switch (name) {
    case 'firstName':
      return nameValidator(value, 'First');

    case 'lastName':
      return nameValidator(value, 'Last');

    case 'email':
      if (!validator.isEmail(value)) {
        return 'Please enter a valid email address.';
      }
      break;

    case 'phone':
      if (
        !shouldShowPhoneNumberInput ||
        validator.isEmpty(trimDialCode(value, dialCode))
      ) {
        return '';
      }

      if (
        !validator.isLength(trimDialCode(value, dialCode), { min: 4, max: 15 })
      ) {
        return 'Phone number must be 10 digits.';
      }
      break;

    case 'password':
      if (!passwordValidator.all(value)) {
        return 'Password must contain at least one upper case, lowercase and a number';
      }
      break;
    default:
      break;
  }

  return '';
};
